import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
} from '@angular/core';
import { OverlayRef, TelXLOverlayComponent } from '@dxp/components';
import { TelXLButtonComponent } from '@dxp/elements';

@Component({
    selector: 'end-customer-merge-customer',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TelXLOverlayComponent, TelXLButtonComponent],
    templateUrl: './merge-customer.component.html',
    styleUrl: './merge-customer.component.scss',
})
export class MergeCustomerModalComponent {
    readonly #overlayRef = inject(OverlayRef<boolean>);

    mergeWith = input.required<string>();
    mergeWithName = computed<string>(() => {
        return this.mergeWith() && this.mergeWith().length > 0
            ? this.mergeWith()
            : 'Unknown Customer';
    });

    close(result: boolean) {
        this.#overlayRef.close(result);
    }
}
